import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=2022fe15&"
import script from "./whatsapp.vue?vue&type=script&lang=js&"
export * from "./whatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports